// extracted by mini-css-extract-plugin
export default {"wrapperBonusButton":"BonusButton_wrapperBonusButton__k3XGo","count":"BonusButton_count__qL3Ai"};